import "styles/sharedStyles/loading.scss";
import myprofilebig from "../images/myprofilebig.svg";
import myprofilesmall from "../images/myprofilesmall.svg";

const Loading = () => {
    return (
        <div className="loading">
            <img src={myprofilesmall} className="smallloading" alt="" />
            <img src={myprofilebig} className="bigloading" alt="" />
        </div>
    );
};

export default Loading;
